import { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';

import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';

import NavBar from './components/NavBar';
import Sidebar from './components/SideBar';

import EventList from './pages/event/List';
import EventDetails from './pages/event/Details';

import CompanyList from './pages/company/List';
// import CompanyForm from './pages/company/Create';
import CompanyForm from './pages/company/Create_no_validation';
// import CompanyForm from './pages/company/Create_修改schema但出錯';
import CompanyDetail from './pages/company/Detail';
import CompanyTeams from './pages/company/Teams';
import CompanyTeamsActivity from './pages/company/TeamsActivity';

import CouponList from './pages/promotion-coupon/List';
import CouponDetails from './pages/promotion-coupon/Details';
import PromotionOfferList from './pages/promotion-offer/List';
import PromotionOfferDetails from './pages/promotion-offer/Details';

import AccountList from './pages/account-admin/List';
import AccountForm from './pages/account-admin/Details';

import MemberAccountList from './pages/member-account/List';
import MemberAccountForm from './pages/member-account/Details';
import MemberSubscriptionList from './pages/member-order/List';
import MemberSubscriptionDetails from './pages/member-order/Details';
import MemberActivityList from './pages/member-activity/List';
import MemberActivityDetails from './pages/member-activity/Details';

import Homepage from './pages/Homepage';
import ProfileForm from './pages/profile/Details';

import { useAuth } from './contexts/AuthContext';

function App() {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (/^\/(?:login|forgot-password|resetpkey\/[^\/]+)$/.test(location?.pathname)) {
      if (user) {
        navigate("/");
      }
    }
  }, [location]);

  return (
    <>
      {(isAuthenticated && user) && (
        <>
          <NavBar />
          <Sidebar />
        </>  
      )}
      
      {/* 設定 padding 來避免內容被 Sidebar 開合按鈕覆蓋 */}
      {/* <div className="ps-12"> */}
      <div className={`${user ? "pt-[calc(66px+1.25rem)] ps-72" : ""}`}>
        <Routes>
          {/* 公開路由 */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/resetpkey/:token" element={<ResetPassword />} />

          {/* 需要驗證的路由 */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Homepage />} />
            <Route path="/profile" element={<ProfileForm />} />
            <Route path="/admin" element={<AccountList />} />
            <Route path="/admin/new" element={<AccountForm />} />
            <Route path="/admin/:id" element={<AccountForm />} />
            <Route path="/member/account" element={<MemberAccountList />} />
            <Route path="/member/account/:id" element={<MemberAccountForm />} />
            <Route path="/member/subscription" element={<MemberSubscriptionList />} />
            <Route path="/member/subscription/:id" element={<MemberSubscriptionDetails />} />
            <Route path="/member/activity" element={<MemberActivityList />} />
            <Route path="/member/activity/:id" element={<MemberActivityDetails />} />
            <Route path="/coupon" element={<CouponList />} />
            <Route path="/coupon/new" element={<CouponDetails />} />
            <Route path="/coupon/:id" element={<CouponDetails />} />
            <Route path="/promotion/offer" element={<PromotionOfferList />} />
            <Route path="/promotion/offer/new" element={<PromotionOfferDetails />} />
            <Route path="/promotion/offer/:id" element={<PromotionOfferDetails />} />
            <Route path="/company" element={<CompanyList />} />
            <Route path="/company/profile" element={<CompanyList />} />
            <Route path="/company/profile/new" element={<CompanyForm />} />
            <Route path="/company/profile/:uuid" element={<CompanyDetail />} />
            <Route path="/company/profile/:uuid/edit" element={<CompanyForm />} />
            <Route path="/event" element={<EventList />} />
            <Route path="/event/new" element={<EventDetails />} />
            <Route path="/event/:id" element={<EventDetails />} />
          </Route>
        </Routes>
      </div>
    </>
  );
}

export default App;